<script lang="ts" setup>
import type { ProductProperty, ProductPropertyGroup } from '~/types/Catalog';

const props = defineProps<{ productProperties: ProductProperty[]; productPropertiesGroups?: ProductPropertyGroup[] }>();

const groups = ref(
  props.productPropertiesGroups && props.productPropertiesGroups.length
    ? props.productPropertiesGroups?.map((group) => ({
        ...group,
        show: true,
      }))
    : [],
);

const isShowUngroupedItems = ref(true);
</script>

<template>
  <div v-if="groups.length">
    <div
      v-for="group in groups.sort((a, b) => a.priority - b.priority)"
      :key="group.title"
    >
      <button
        class="product-page-characteristics-block__title"
        @click="group.show = !group.show"
      >
        {{ group.title }}

        <SvgoChevronDown
          :class="{ 'rotate-180': group.show }"
          :font-controlled="false"
          class="size-4"
          filled
        />
      </button>

      <FoldableBlock v-model="group.show">
        <div
          v-for="property in productProperties.filter((p) => p.group_id === group.id)"
          :key="property.value"
          class="product-page-characteristics-block__item"
        >
          <div>{{ property.name }}</div>

          <div>{{ property.value }}</div>
        </div>
      </FoldableBlock>
    </div>

    <template v-if="productProperties.filter((p) => !p.group_id).length">
      <button
        class="product-page-characteristics-block__title"
        @click="isShowUngroupedItems = !isShowUngroupedItems"
      >
        Остальные

        <SvgoChevronDown
          :class="{ 'rotate-180': isShowUngroupedItems }"
          :font-controlled="false"
          class="size-4"
          filled
        />
      </button>

      <FoldableBlock v-model="isShowUngroupedItems">
        <div
          v-for="property in productProperties.filter((p) => !p.group_id)"
          :key="property.value"
          class="product-page-characteristics-block__item"
        >
          <div>{{ property.name }}</div>

          <div>{{ property.value }}</div>
        </div>
      </FoldableBlock>
    </template>
  </div>

  <div v-else>
    <div
      v-for="property in productProperties"
      :key="property.value"
      class="product-page-characteristics-block__item"
    >
      <div>{{ property.name }}</div>

      <div>{{ property.value }}</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.product-page-characteristics-block {
  &__title {
    display: flex;
    gap: 8px;
    align-items: center;
    padding: 8px 12px;
    font-weight: bold;
  }

  &__item {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
    padding: 8px 12px;

    &:nth-child(odd) {
      background-color: $hell-black-10;
    }
  }
}
</style>
